<template>
  <div>
      <el-table
        border 
        highlight-current-row
        :data="tableData"
        :default-sort="{ prop: 'gsje', order: 'descending' }"
        style="width: 100%"
        @current-change="handleCurrentChange"
        >
            <el-table-column type="index" label="序号" min-width="10%" />
            <el-table-column prop="fundcode" label="代码" min-width="14%" />
            <el-table-column prop="name" label="名称" min-width="18%" />
            <el-table-column label="持有金额" :formatter="amountFormat" min-width="18%" sortable :sort-by="amountSort"  />
            <el-table-column prop="gszzl" label="估算涨幅" min-width="18%" :formatter="gszzlFormat" sortable />
            <el-table-column prop="gsje" label="估算金额" min-width="18%" sortable>
                <template v-slot:default="slotProps">
                    <el-tag
                        :type="slotProps.row.gsje >0 ? 'danger' : 'success'"
                        disable-transitions
                    >
                        {{ slotProps.row.gsje.toFixed(0) }}
                    </el-tag>
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<style>
    .myred{
        color:red;
    }
</style>

<script>
export default {
    name:'ListView',
    props:{
        tableData:{
            type:Array,
            default:[]
        },
        selectedRow:{
            type:Object,
            default:null
        }
    },
    data(){
        return{
            currentRow: this.currentRow,
        }
    },
    methods: {
        amountSort(row,index){
            return Number(row.amount*row.dwjz)
        }, 
        amountFormat(row,column){
            return Number(row.amount*row.dwjz).toFixed(0)
        },
        gszzlFormat(row)
        {
            return Number(row.gszzl).toFixed(2)+'%'
        },
        handleCurrentChange(val) {
            this.currentRow = val
            this.$emit('handlerListSelected',val)
        },
    },
}
</script>

<style lang="less" scoped>
    /deep/ .je-color-red{
        // color: #fde2e2;
        color: red;
    }
    /deep/ .je-color-green{
        // color: #e1f3d8;
        color:green;
    }
</style>